var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.774,
    height: 26.236,
    viewBox: "0 0 35.774 26.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loop",
    transform: "translate(0 -4.253)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85336",
    "data-name": "Path 85336",
    d: "M13.113,24.54H5.959a3.577,3.577,0,0,1-3.577-3.577V13.808a3.577,3.577,0,0,1,3.577-3.577H17.887A1.207,1.207,0,0,0,18.725,8.2L15.148,4.619a1.21,1.21,0,1,0-1.733,1.688l1.543,1.543h-9A5.97,5.97,0,0,0,0,13.808v7.155a5.959,5.959,0,0,0,5.959,5.959h7.155a1.2,1.2,0,1,0,0-2.381Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85337",
    "data-name": "Path 85337",
    d: "M32.266,9.185a5.925,5.925,0,0,0-4.215-1.744H20.9a1.2,1.2,0,1,0,0,2.381h7.155A3.577,3.577,0,0,1,31.629,13.4v7.155a3.577,3.577,0,0,1-3.577,3.577H16.123a1.207,1.207,0,0,0-.838,2.035l3.577,3.577a1.2,1.2,0,1,0,1.733-1.655l-1.543-1.543H28.1a5.97,5.97,0,0,0,5.914-5.959V13.433a5.925,5.925,0,0,0-1.744-4.248Z",
    transform: "translate(1.764 0.375)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.b69857d1f43249d0891a5e591f1633b0.svg";
export { ForwardRef as ReactComponent };